import CloseIcon from "@mui/icons-material/Close"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { toast } from "react-toastify"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"

import CustomTextField from "../CustomTextField"

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { es } from "date-fns/locale"
import { Controller } from "react-hook-form"

import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { DialogTitle, IconButton } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { MuiFileInput } from "mui-file-input"
import { useDispatch, useSelector } from "react-redux"
import { cargarAdjuntoSolicitud, solucitudActualizacionEducacion } from "../../Redux/solicitudes"
import { UserAuth } from "../../context/AuthContext"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { useEffect, useState } from "react"
import { obtenerSubdisciplinas, obtenerUniversidades } from "../../Redux/autocompletados"
import CustomDateField from "../CustomDateField"

const ModalSolicitudEducacion = ({ open, handleClose }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const { empleado } = UserAuth()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const subdiciplinasSelect = useSelector((store) => store.autocompletados.subdiciplinas); 
  const loadingUniversidades = useSelector((store) => store.autocompletados.loadingUniversidades);
  const estadoSolicitudEducacion = useSelector((store) => store.solicitudes.estadoSolicitudEducacion);

  const [selectedFiles, setSelectedFiles] = useState([])
  const [subdiciplinas, setSubdiciplinas] = useState([])
  const [universidades, setUniversidades] = useState([])

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile)
  }

  useEffect(() => {
    if (token) {
      dispatch(obtenerSubdisciplinas(token));
      dispatch(obtenerUniversidades(token))
    }
  }, [token]);

  useEffect(() => {
    if (subdiciplinasSelect?.length > 0) {
      const subdiciplinas = [];
      subdiciplinasSelect.forEach((item) => {
        const object = {
          value: item.new_subdisciplinaid,
          label: item.new_name,
        };
        subdiciplinas.push(object);
      });
      setSubdiciplinas(subdiciplinas);
    }
  }, [subdiciplinasSelect]);

  useEffect(() => {
    if (loadingUniversidades?.length > 0) {
      const universidades = [];
      loadingUniversidades.forEach((item) => {
        const object = {
          value: item.new_universidadid,
          label: item.new_name,
        };
        universidades.push(object);
      });
      setUniversidades(universidades);
    }
  }, [loadingUniversidades]);

  const defaultValues = {
    asunto: "",
    titulo: "",
    tipoCarrera: null,
    institucionOtorgante: null,
    carreraSubdisciplina: null,
    fechaIngreso: "",
    fechaEgreso: "",
  }

  const validacionSchema = yup.object().shape({
    asunto: yup.string().required("Por favor indica el asunto."),
    tipoCarrera: yup.object({ value: yup.string().required("El tipo de carrera es requerido") }),
    institucionOtorgante: yup.object({ value: yup.string().required("El tipo de institución es requerido") }),
    fechaIngreso: yup.string().required("Required"),
    fechaEgreso: yup.string().required("Required"),
  })

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit } = methods

  const submitDatos = (datos) => {
    const formData = new FormData()
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        setSelectedFiles([])
        return
      }
      let element = selectedFiles[index]
      formData.append(`body${index}`, element)
    }
    dispatch(solucitudActualizacionEducacion(token, datos, empleado.empleadoid))
    .then((id) => {
      handleClose()
      if(selectedFiles.length > 0 && id.length > 0){
        dispatch(cargarAdjuntoSolicitud(token, formData, id, 'educacionFormal_id'))
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }

  const opcionesTipoCarrera = [
    { value: "", label: "Seleccione una opción" },
    { value: "100000000", label: "Especialización" },
    { value: "100000001", label: "Carrera de grado" },
    { value: "100000002", label: "Maestría" },
    { value: "100000003", label: "Doctorado" },
    { value: "100000004", label: "Terciario" },
    { value: "100000005", label: "Formacion docente" },
  ]

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="asunto"
                label="Asunto"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el asunto."
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="titulo" label="Título" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesTipoCarrera}
                req="true"
                type="text"
                name="tipoCarrera"
                lab="Tipo de carrera"
                helperText="El tipo de carrera es requerido"
              />
            </Grid>

            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                  options={universidades}
                  req="true"
                  type="text"
                  name="institucionOtorgante"
                  lab="Institución otorgante"
                  helperText="Por favor indica la institución."
                />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                  options={subdiciplinas}
                  type="text"
                  name="carreraSubdisciplina"
                  lab="Carrera subdisciplina coneau"
              />
            </Grid>

            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaIngreso"
                label="Fecha de solicitud:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de ingreso"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaEgreso"
                label="Fecha de egreso:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de egreso"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput value={selectedFiles} multiple label="Adjuntar documento" onChange={changeHandler} fullWidth />
            </Grid>
            <Grid sx={{ px: 2, mb: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>El tamaño máximo permitido por archivo es de 15 MB</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={estadoSolicitudEducacion === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSolicitudEducacion
